import { css } from '@emotion/css';
import { makeStyles } from '@material-ui/core';
import Color from 'styles/colors';

export const header = css`
  padding: 0 20px;
`;

export const sortingDrawer = css`
  .MuiDrawer-paper {
    padding: 34px 0 50px 0;
    border-radius: 16px 16px 0px 0px;
    max-width: 36rem;
    margin: 0 auto;
  }
`;

export const sliderRow = css`
  padding: 56px 20px 16px 20px;
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid ${Color.Gray[30]};
`;

export const sliderLane = css`
  display: flex;
  align-items: center;
`;

export const sliderLeftIcon = css`
  margin-right: 20px;
`;

export const sliderRightIcon = css`
  margin-left: 24px;
`;

export const sliderAnnotation = css`
  display: flex;
  // margin-top: 8px;
  margin: 8px 8px 0px 16px;
  justify-content: space-between;
  color: ${Color.Blue[60]};
`;

export const selectableCellRow = css`
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 56px;
`;

export const useStyles = makeStyles(() => ({
  root: {
    padding: '0',
  },
  thumb: {
    width: 31,
    height: 31,
    border: `4px solid ${Color.Blue[60]}`,
    color: 'white',
    marginTop: -14,
    marginLeft: -14,
    boxShadow: '0px 2px 8px rgba(17, 23, 35, 0.1), inset 0px -2px 2px rgba(17, 23, 35, 0.1)',
  },
  track: {
    height: 2,
    color: Color.Gray[70],
  },
  rail: {
    height: 2,
    color: Color.Gray[70],
  },
  mark: {
    backgroundColor: Color.Transparent,
    height: 60,
    width: 60,
    marginTop: -29,
    marginLeft: -30,
    '&::before': {
      content: '""',
      backgroundColor: Color.White,
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      borderRadius: '50%',
      width: 11,
      height: 11,
      border: `2px solid ${Color.Gray[70]}`,
    },
  },
  marked: {
    margin: '0',
  },
  markLabel: {
    top: -36,
    color: Color.Blue[60],
    fontSize: '12px',
  },
}));
